import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Connection from "../../elements/connection/Connection";
import { Alert } from "@material-ui/lab";
import PageSpinner from "../../elements/spinner/PageSpinner";
import MaterialSwitch from "../../styles/materialSwitch";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import DialogModal from "../../elements/dialogModal/DialogModal";
import TwoFa from "../../elements/twoFa/TwoFa";
import { check2FA } from "../../../utils/check2FA";
import getUserInfo from "../../../utils/getUserInfo";
import { useTranslation } from "react-i18next";

import { StyledServiceGrid, StyledServiceLink, StyledServiceLinkWrapper } from "../styledServices";

const ServiceList = ({ services, fetchServicesList, notification, setNotification }) => {
  const { t } = useTranslation("servicePage");
  const [error, setError] = useState({});
  const [open, setOpen] = useState(false);
  const [changeService, setChangeService] = useState({
    id: null,
    enable: null
  });

  const handleChange = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    let data = {
      enable: changeService.enable
    };

    axios.put("/api/services/" + changeService.id, data, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        fetchServicesList();
        setOpen(false);
        setNotification({
          ...notification,
          visible: true,
          type: "success",
          message: t("list.success")
        });
      }
    }).catch(error => {
      setOpen(false);
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  if (!services) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (services.length === 0) {
    return <Alert severity="warning">{t("list.emptyData")}</Alert>;
  }

  const showDetails = (e) => {
    if (e.target.closest(".stop-event")) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <>
      <DialogModal
        open={open}
        setOpen={setOpen}
        title={t("details.addForm.twoFaTitle")}
        content={<TwoFa
          handleSubmit={handleChange}
          error={error}
        />}
      />
      <StyledServiceGrid>
        {services && services.map((value, key) => (
          <StyledServiceLinkWrapper key={key}>
            <div className="connection__action stop-event">
              <label className="connection__label">
                <MaterialSwitch
                  checked={value.enable}
                  onChange={event => {
                    setChangeService({ ...changeService, id: value.id, enable: event.target.checked });
                    setOpen(true);
                  }}
                  name={value.name}
                />
              </label>
            </div>
            <StyledServiceLink
              onClick={(e) => {showDetails(e);}}
              as={NavLink}
              to={`/services/${value.id}`}
            >
              <Connection
                name={value.name}
                nickname={value.nickname}
              />
            </StyledServiceLink>
          </StyledServiceLinkWrapper>
        ))}
      </StyledServiceGrid>
    </>
  );
};
export default ServiceList;